import React, { ReactNode } from 'react';
import { Label as UILabel } from 'ui-library';
import './FieldControl.css';

interface FieldControlProps {
    label?: string;
    value?: string | undefined;
    editable?: boolean;
    editComponent?: ({ label, value } : {label: string; value: unknown}) => ReactNode;
    renderValue?: (value: string | undefined) => ReactNode;
}

const FieldControl = ({
    label = '',
    value = undefined,
    editable = false,
    renderValue = v => v,
    editComponent = () => null,
}: FieldControlProps) => {
    if (editable) {
        return editComponent({
            label,
            value,
        });
    }

    return (
        <div className="field-control">
            <UILabel label={label}/>
            <p>
                {renderValue(value)}
            </p>
        </div>
    );
};

export default FieldControl;
